import { Navigate, Outlet, useLocation } from 'react-router-dom';

type AllowedRole = 'master' | 'client';

interface ProtectedRouteProps {
    allowedRoles?: AllowedRole[];
    allowInactiveClientPaths?: string[];
}

export default function ProtectedRoute({
    allowedRoles,
    allowInactiveClientPaths = [],
}: ProtectedRouteProps) {
    const token = localStorage.getItem('token');
    const userRaw = localStorage.getItem('user');
    const location = useLocation();

    if (!token || !userRaw) {
        return <Navigate to="/login" replace />;
    }

    const user = JSON.parse(userRaw);

    const isMaster = !!user?.is_master;
    const isClient = user?.role === 'client';
    const subscriptionActive = !!user?.site?.subscription_active;

    if (allowedRoles?.length) {
        const canAccessAsMaster = allowedRoles.includes('master') && isMaster;
        const canAccessAsClient = allowedRoles.includes('client') && isClient;

        if (!canAccessAsMaster && !canAccessAsClient) {
            return <Navigate to={isMaster ? '/master/dashboard' : '/dashboard'} replace />;
        }
    }

    if (isClient && !subscriptionActive) {
        const allowedPaths = [
            '/onboarding',
            '/servicos',
            '/pagamento',
            '/confirmacao',
            ...allowInactiveClientPaths,
        ];

        if (!allowedPaths.includes(location.pathname)) {
            return <Navigate to="/onboarding" replace />;
        }
    }

    return <Outlet />;
}